import { render } from "./MoneyBack.vue?vue&type=template&id=5c96ad56&scoped=true"
import script from "./MoneyBack.vue?vue&type=script&lang=js"
export * from "./MoneyBack.vue?vue&type=script&lang=js"

import "./MoneyBack.vue?vue&type=style&index=0&id=5c96ad56&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c96ad56"]])

export default __exports__